<template>
  <transition name="overlay-fade">
    <div
      v-show="visible"
      class="v-overlay"
      :style="cssStyle"
      @click.stop.prevent="onClick"
      @contextmenu.stop.prevent="() => {}"
      @dragover.prevent
      @drop.prevent
    />
  </transition>
</template>

<script lang="ts">
import { Options, Vue, Prop, Emit } from 'vue-property-decorator/lib';

@Options({
  name: 'VOverlay',
  inheritAttrs: false,
})
export default class VOverlay extends Vue {
  @Prop({ default: false }) visible: boolean;
  @Prop({ default: 0.3 }) duration: number;
  @Prop({ default: null }) readonly zIndex: number;
  @Prop({ default: null }) readonly background: string;

  get cssStyle(): Record<string, unknown> {
    return {
      'animation-duration': `${this.duration}s`,
      background: this.background ?? '',
      zIndex: this.zIndex ?? '',
    };
  }

  @Emit('click')
  onClick(e: MouseEvent | TouchEvent): MouseEvent | TouchEvent {
    return e;
  }
}
</script>

<style lang="scss" src="./index.scss" scoped></style>
